import { useState } from 'react';
import { isValidMobile } from '../utils/validation';

const MobileNumberInput = ({ value, onChange, showOptionalLabel = false }) => {
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const inputValue = e.target.value;
    onChange(inputValue);

    if (inputValue && !isValidMobile(inputValue)) {
      setError('Please enter a valid mobile number');
    } else {
      setError('');
    }
  };

  const handleBlur = () => {
    // Allow optional field to be empty
    if (!value) {
      setError('');
    }
  };

  return (
    <div className="form-block mobile-input-block">
      <label htmlFor="mobileNumber" style={{ fontWeight: 'bold' }}>
        Mobile Number
        {showOptionalLabel && <span className="optional-label"> (optional)</span>}
      </label>
      <input
        id="mobileNumber"
        type="tel"
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder="Enter your mobile number (e.g., +441234567890)"
        maxLength="20"
        className={error ? 'input-error' : ''}
      />
      {error && <p className="field-error-message">{error}</p>}
    </div>
  );
};

export default MobileNumberInput;
